import styled from 'styled-components';

export const StyledPatientGroupField = styled.div`
   width: 248px;
`;
StyledPatientGroupField.displayName = 'StyledPatientGroupField';
